import { Image, Wrapper } from './splash_screen.styles';

import { VENDOR_BUSINESS_NAME } from '../constants';

import logo from '../static/splash/logo.svg';

export default function SplashScreen() {
  return (
    <Wrapper>
      <Image src={logo} alt={VENDOR_BUSINESS_NAME} />
    </Wrapper>
  );
}
